import(/* webpackMode: "eager" */ "/app/src/app/courses/page.tsx");
